export default function Arrowright() {
return(
<svg xmlns="http://www.w3.org/2000/svg" width="63" height="16" viewBox="0 0 63 16" fill="none">
  <path d="M61.8621 8.95369C62.2527 8.56316 62.2527 7.93 61.8621 7.53948L55.4982 1.17551C55.1077 0.78499 54.4745 0.78499 54.084 1.17551C53.6934 1.56604 53.6934 2.1992 54.084 2.58973L59.7408 8.24658L54.084 13.9034C53.6934 14.294 53.6934 14.9271 54.084 15.3176C54.4745 15.7082 55.1077 15.7082 55.4982 15.3176L61.8621 8.95369ZM0.969727 9.24658H61.155V7.24658H0.969727V9.24658Z" fill="black"/>
</svg>
)
}
